/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SentryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Sentry Tunnel
     * Proxy Sentry envelopes from the browser to Bugsink/Sentry server-side.
     *
     * Avoids CORS and mixed-content restrictions: the browser POST to same origin,
     * and the backend forwards over a server-side connection (no CORS, HTTP allowed).
     *
     * Security: only forwards to the configured SENTRY_DSN host, preventing SSRF abuse.
     * @returns any Successful Response
     * @throws ApiError
     */
    public sentryTunnelApiV1SentryTunnelPost(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/sentry/tunnel',
        });
    }
}
